import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container, Box, Typography } from "@mui/material";
import UserProfile from "../../../../user_job_request/parts/UserProfile";
import JobRequestDetail from "../../../../user_job_request/parts/JobRequestDetail";

const UserJobRequestPage = ({}) => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [userJobRequestInfo, setUserJobRequestInfo] = useState(null);
  const [userJobRequest, setUserJobRequest] = useState(null);

  useEffect(() => {
    fetch(`/company/candidates/${id}/job_request.json`)
      .then((res) => res.json())
      .then((data) => {
        setUserJobRequestInfo(data.user_job_request_info);
        setUserJobRequest(data.user_job_request);
        setLoading(false);
      });
  }, [id]);

  // データ未取得時のローディング表示
  if (loading) {
    return (
      <Box p={4} ml={4}>
        <Typography>読み込み中...</Typography>
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ bgcolor: "white" }}>
        {/* プロフィール */}
        <UserProfile
          userJobRequestInfo={userJobRequestInfo}
          viewerType="company"
        />
      </Box>

      <Container maxWidth="md" sx={{ my: 5 }}>
        {/* 募集要項 */}
        <JobRequestDetail
          userJobRequestInfo={userJobRequestInfo}
          userJobRequest={userJobRequest}
          viewerType="company"
        />
      </Container>
    </>
  );
};

export default UserJobRequestPage;
